export const IS_LOADED = 'IS_LOADED'
export const AGENTS_ONLINE = 'AGENTS_ONLINE'
export const SET_API = 'SET_API'
export const SET_ELEMENT = 'SET_ELEMENT'
